import { B2BColorConfig, defaultB2BColors } from "@hopper-b2b/types";

export const colors: B2BColorConfig = defaultB2BColors;
